var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"poll-option-view"},[_c('textfield',{attrs:{"label":_vm.getLabel()},model:{value:(_vm.pollOption.Text),callback:function ($$v) {_vm.$set(_vm.pollOption, "Text", $$v)},expression:"pollOption.Text"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }